const countries = [
  { id: 'AD', name: 'Andorra' },
  { id: 'AE', name: 'United Arab Emirates' },
  { id: 'AF', name: 'Afghanistan' },
  { id: 'AG', name: 'Antigua & Barbuda' },
  { id: 'AI', name: 'Anguilla' },
  { id: 'AL', name: 'Albania' },
  { id: 'AM', name: 'Armenia' },
  { id: 'AO', name: 'Angola' },
  { id: 'AR', name: 'Argentina' },
  { id: 'AS', name: 'American Samoa' },
  { id: 'AT', name: 'Austria' },
  { id: 'AU', name: 'Australia' },
  { id: 'AW', name: 'Aruba' },
  { id: 'AX', name: 'Åland Islands' },
  { id: 'AZ', name: 'Azerbaijan' },
  { id: 'BA', name: 'Bosnia & Herzegovina' },
  { id: 'BB', name: 'Barbados' },
  { id: 'BD', name: 'Bangladesh' },
  { id: 'BE', name: 'Belgium' },
  { id: 'BF', name: 'Burkina Faso' },
  { id: 'BG', name: 'Bulgaria' },
  { id: 'BH', name: 'Bahrain' },
  { id: 'BI', name: 'Burundi' },
  { id: 'BJ', name: 'Benin' },
  { id: 'BL', name: 'St. Barthélemy' },
  { id: 'BM', name: 'Bermuda' },
  { id: 'BN', name: 'Brunei' },
  { id: 'BO', name: 'Bolivia' },
  { id: 'BR', name: 'Brazil' },
  { id: 'BS', name: 'Bahamas' },
  { id: 'BT', name: 'Bhutan' },
  { id: 'BV', name: 'Bouvet Island' },
  { id: 'BW', name: 'Botswana' },
  { id: 'BY', name: 'Belarus' },
  { id: 'BZ', name: 'Belize' },
  { id: 'CA', name: 'Canada' },
  { id: 'CC', name: 'Cocos (Keeling) Islands' },
  { id: 'CD', name: 'Congo - Kinshasa' },
  { id: 'CF', name: 'Central African Republic' },
  { id: 'CG', name: 'Congo - Brazzaville' },
  { id: 'CH', name: 'Switzerland' },
  { id: 'CI', name: 'Côte d’Ivoire' },
  { id: 'CK', name: 'Cook Islands' },
  { id: 'CL', name: 'Chile' },
  { id: 'CM', name: 'Cameroon' },
  { id: 'CN', name: 'China' },
  { id: 'CO', name: 'Colombia' },
  { id: 'CR', name: 'Costa Rica' },
  { id: 'CU', name: 'Cuba' },
  { id: 'CV', name: 'Cape Verde' },
  { id: 'CW', name: 'Curaçao' },
  { id: 'CX', name: 'Christmas Island' },
  { id: 'CY', name: 'Cyprus' },
  { id: 'CZ', name: 'Czech Republic' },
  { id: 'DE', name: 'Germany' },
  { id: 'DJ', name: 'Djibouti' },
  { id: 'DK', name: 'Denmark' },
  { id: 'DM', name: 'Dominica' },
  { id: 'DO', name: 'Dominican Republic' },
  { id: 'DZ', name: 'Algeria' },
  { id: 'EC', name: 'Ecuador' },
  { id: 'EE', name: 'Estonia' },
  { id: 'EG', name: 'Egypt' },
  { id: 'ER', name: 'Eritrea' },
  { id: 'ES', name: 'Spain' },
  { id: 'ET', name: 'Ethiopia' },
  { id: 'EU', name: 'European Union' },
  { id: 'FI', name: 'Finland' },
  { id: 'FJ', name: 'Fiji' },
  { id: 'FK', name: 'Falkland Islands' },
  { id: 'FM', name: 'Micronesia' },
  { id: 'FO', name: 'Faroe Islands' },
  { id: 'FR', name: 'France' },
  { id: 'GA', name: 'Gabon' },
  { id: 'GB', name: 'United Kingdom' },
  { id: 'GD', name: 'Grenada' },
  { id: 'GE', name: 'Georgia' },
  { id: 'GF', name: 'French Guiana' },
  { id: 'GG', name: 'Guernsey' },
  { id: 'GH', name: 'Ghana' },
  { id: 'GI', name: 'Gibraltar' },
  { id: 'GL', name: 'Greenland' },
  { id: 'GM', name: 'Gambia' },
  { id: 'GN', name: 'Guinea' },
  { id: 'GP', name: 'Guadeloupe' },
  { id: 'GQ', name: 'Equatorial Guinea' },
  { id: 'GR', name: 'Greece' },
  { id: 'GS', name: 'So. Georgia & So. Sandwich Isl.' },
  { id: 'GT', name: 'Guatemala' },
  { id: 'GU', name: 'Guam' },
  { id: 'GW', name: 'Guinea-Bissau' },
  { id: 'GY', name: 'Guyana' },
  { id: 'HK', name: 'Hong Kong (China)' },
  { id: 'HM', name: 'Heard & McDonald Islands' },
  { id: 'HN', name: 'Honduras' },
  { id: 'HR', name: 'Croatia' },
  { id: 'HT', name: 'Haiti' },
  { id: 'HU', name: 'Hungary' },
  { id: 'ID', name: 'Indonesia' },
  { id: 'IE', name: 'Ireland' },
  { id: 'IL', name: 'Israel' },
  { id: 'IM', name: 'Isle of Man' },
  { id: 'IN', name: 'India' },
  { id: 'IO', name: 'British Indian Ocean Territory' },
  { id: 'IQ', name: 'Iraq' },
  { id: 'IR', name: 'Iran' },
  { id: 'IS', name: 'Iceland' },
  { id: 'IT', name: 'Italy' },
  { id: 'JE', name: 'Jersey' },
  { id: 'JM', name: 'Jamaica' },
  { id: 'JO', name: 'Jordan' },
  { id: 'JP', name: 'Japan' },
  { id: 'KE', name: 'Kenya' },
  { id: 'KG', name: 'Kyrgyzstan' },
  { id: 'KH', name: 'Cambodia' },
  { id: 'KI', name: 'Kiribati' },
  { id: 'KM', name: 'Comoros' },
  { id: 'KN', name: 'St. Kitts & Nevis' },
  { id: 'KP', name: 'North Korea' },
  { id: 'KR', name: 'South Korea' },
  { id: 'KW', name: 'Kuwait' },
  { id: 'KY', name: 'Cayman Islands' },
  { id: 'KZ', name: 'Kazakhstan' },
  { id: 'LA', name: 'Laos' },
  { id: 'LB', name: 'Lebanon' },
  { id: 'LC', name: 'St. Lucia' },
  { id: 'LI', name: 'Liechtenstein' },
  { id: 'LK', name: 'Sri Lanka' },
  { id: 'LR', name: 'Liberia' },
  { id: 'LS', name: 'Lesotho' },
  { id: 'LT', name: 'Lithuania' },
  { id: 'LU', name: 'Luxembourg' },
  { id: 'LV', name: 'Latvia' },
  { id: 'LY', name: 'Libya' },
  { id: 'MA', name: 'Morocco' },
  { id: 'MC', name: 'Monaco' },
  { id: 'MD', name: 'Moldova' },
  { id: 'ME', name: 'Montenegro' },
  { id: 'MF', name: 'St. Martin' },
  { id: 'MG', name: 'Madagascar' },
  { id: 'MH', name: 'Marshall Islands' },
  { id: 'MK', name: 'Macedonia' },
  { id: 'ML', name: 'Mali' },
  { id: 'MM', name: 'Myanmar (Burma)' },
  { id: 'MN', name: 'Mongolia' },
  { id: 'MO', name: 'Macau (China)' },
  { id: 'MP', name: 'Northern Mariana Islands' },
  { id: 'MQ', name: 'Martinique' },
  { id: 'MR', name: 'Mauritania' },
  { id: 'MS', name: 'Montserrat' },
  { id: 'MT', name: 'Malta' },
  { id: 'MU', name: 'Mauritius' },
  { id: 'MV', name: 'Maldives' },
  { id: 'MW', name: 'Malawi' },
  { id: 'MX', name: 'Mexico' },
  { id: 'MY', name: 'Malaysia' },
  { id: 'MZ', name: 'Mozambique' },
  { id: 'NA', name: 'Namibia' },
  { id: 'NC', name: 'New Caledonia' },
  { id: 'NE', name: 'Niger' },
  { id: 'NF', name: 'Norfolk Island' },
  { id: 'NG', name: 'Nigeria' },
  { id: 'NI', name: 'Nicaragua' },
  { id: 'NL', name: 'Netherlands' },
  { id: 'NO', name: 'Norway' },
  { id: 'NP', name: 'Nepal' },
  { id: 'NR', name: 'Nauru' },
  { id: 'NU', name: 'Niue' },
  { id: 'NZ', name: 'New Zealand' },
  { id: 'OM', name: 'Oman' },
  { id: 'PA', name: 'Panama' },
  { id: 'PE', name: 'Peru' },
  { id: 'PF', name: 'French Polynesia' },
  { id: 'PG', name: 'Papua New Guinea' },
  { id: 'PH', name: 'Philippines' },
  { id: 'PK', name: 'Pakistan' },
  { id: 'PL', name: 'Poland' },
  { id: 'PM', name: 'St. Pierre & Miquelon' },
  { id: 'PN', name: 'Pitcairn Islands' },
  { id: 'PR', name: 'Puerto Rico' },
  { id: 'PS', name: 'Palestinian Territories' },
  { id: 'PT', name: 'Portugal' },
  { id: 'PW', name: 'Palau' },
  { id: 'PY', name: 'Paraguay' },
  { id: 'QA', name: 'Qatar' },
  { id: 'RE', name: 'Réunion' },
  { id: 'RO', name: 'Romania' },
  { id: 'RS', name: 'Serbia' },
  { id: 'RU', name: 'Russia' },
  { id: 'RW', name: 'Rwanda' },
  { id: 'SA', name: 'Saudi Arabia' },
  { id: 'SB', name: 'Solomon Islands' },
  { id: 'SC', name: 'Seychelles' },
  { id: 'SD', name: 'Sudan' },
  { id: 'SE', name: 'Sweden' },
  { id: 'SG', name: 'Singapore' },
  { id: 'SH', name: 'St. Helena' },
  { id: 'SI', name: 'Slovenia' },
  { id: 'SJ', name: 'Svalbard & Jan Mayen' },
  { id: 'SK', name: 'Slovakia' },
  { id: 'SL', name: 'Sierra Leone' },
  { id: 'SM', name: 'San Marino' },
  { id: 'SN', name: 'Senegal' },
  { id: 'SO', name: 'Somalia' },
  { id: 'SR', name: 'Suriname' },
  { id: 'SS', name: 'South Sudan' },
  { id: 'ST', name: 'São Tomé & Príncipe' },
  { id: 'SV', name: 'El Salvador' },
  { id: 'SX', name: 'Sint Maarten' },
  { id: 'SY', name: 'Syria' },
  { id: 'SZ', name: 'Swaziland' },
  { id: 'TC', name: 'Turks & Caicos Islands' },
  { id: 'TD', name: 'Chad' },
  { id: 'TF', name: 'French Southern Territories' },
  { id: 'TG', name: 'Togo' },
  { id: 'TH', name: 'Thailand' },
  { id: 'TJ', name: 'Tajikistan' },
  { id: 'TK', name: 'Tokelau' },
  { id: 'TL', name: 'Timor-Leste' },
  { id: 'TM', name: 'Turkmenistan' },
  { id: 'TN', name: 'Tunisia' },
  { id: 'TO', name: 'Tonga' },
  { id: 'TR', name: 'Turkey' },
  { id: 'TT', name: 'Trinidad & Tobago' },
  { id: 'TV', name: 'Tuvalu' },
  { id: 'TW', name: 'Taiwan' },
  { id: 'TZ', name: 'Tanzania' },
  { id: 'UA', name: 'Ukraine' },
  { id: 'UG', name: 'Uganda' },
  { id: 'UM', name: 'U.S. Outlying Islands' },
  { id: 'US', name: 'United States' },
  { id: 'US', name: 'California' },
  { id: 'UY', name: 'Uruguay' },
  { id: 'UZ', name: 'Uzbekistan' },
  { id: 'VA', name: 'Vatican City' },
  { id: 'VC', name: 'St. Vincent & Grenadines' },
  { id: 'VE', name: 'Venezuela' },
  { id: 'VG', name: 'British Virgin Islands' },
  { id: 'VI', name: 'U.S. Virgin Islands' },
  { id: 'VN', name: 'Vietnam' },
  { id: 'VU', name: 'Vanuatu' },
  { id: 'WF', name: 'Wallis & Futuna' },
  { id: 'WS', name: 'Samoa' },
  { id: 'XK', name: 'Kosovo' },
  { id: 'YE', name: 'Yemen' },
  { id: 'YT', name: 'Mayotte' },
  { id: 'ZA', name: 'South Africa' },
  { id: 'ZM', name: 'Zambia' },
  { id: 'ZW', name: 'Zimbabwe' },
];
export default countries;
